<template>
  <div class="phone-validate">
    <div v-if="!validPhone" class="form-item">
      <div class="input-block input-phone">
        <img src="../assets/icon-phone.svg" alt class="icon-img" /> |
        <AreaCodeSelect @areaCodeChange="onAreaCodeChange" />
        <input
          v-model="phone"
          maxlength="15"
          placeholder="请输入手机号"
          type="text"
        />
      </div>
      <div v-if="getCode" class="error">{{ phoneError }}</div>
    </div>
    <div v-if="validPhone" class="phone-display">
      手机号 {{ validPhone | phoneHide }}
    </div>
    <div v-if="!validPhone" class="form-item">
      <div class="input-block input-code">
        <img src="../assets/icon-lock.svg" alt class="icon-img" /> |
        <input
          v-model="code"
          maxlength="6"
          placeholder="请输入验证码"
          type="text"
        />
        <div
          v-if="!interval"
          class="get-code"
          :class="{ disabled: !isEnablePhone }"
          @click="getCode"
        >
          获取验证码
        </div>
        <div v-else class="wait-time">
          重新发送
          <span class="time-countdown">{{ times }}</span
          >s
        </div>
      </div>
      <div v-if="codeError" class="error">{{ codeError }}</div>
    </div>
    <div class="form-item btn-confirm-wrapper">
      <div
        class="input-block btn-confirm"
        :class="{
          disabled:
            (!validPhone && (!isEnablePhone || !isEnableCode)) || !isAgree,
        }"
        @click="sendConfirmReq"
      >
        {{ hasQualify ? '已报名' : `立即报名 &nbsp;&nbsp;>` }}
      </div>
    </div>
    <slot></slot>
    <Toast ref="toast"></Toast>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { promiseLock } from '@/lib/decorates';
import Toast from './Toast.vue';
import AreaCodeSelect from '@/components/AreaCodeSelect/AreaCodeSelect.vue';
import trackerLoaded from '@/lib/tracker';
import warnIcon from '../assets/warn.svg';
import okIcon from '../assets/ok-icon.svg';
import { getQueryFromSearch } from '@/lib/util';
const CODE_TIME = 60;
@Component({
  components: {
    Toast,
    AreaCodeSelect,
  },
  filters: {
    phoneHide(value: string) {
      if (!value) {
        return value;
      }
      const reg = /(\d{3})(\d*)(\d{4})/;
      return value.replace(
        reg,
        (fullInput: string, g1: string, g2: string, g3: string) => {
          const len = g2.length;
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          return g1 + new Array(len + 1).join('*') + g3;
        }
      );
    },
  },
})
export default class PhoneValidateRound extends Vue {
  @Prop(String) validPhone!: string;
  @Prop(Boolean) hasQualify!: boolean;
  @Prop(Boolean) isAgree!: boolean;
  phone = '';
  code = '';
  phoneErrMsg = '';
  validErrMSg = '';
  interval: any = null;
  times = CODE_TIME;
  area = '86';

  get isEnablePhone() {
    const reg = /^\d+$/;
    return reg.test(this.phone);
  }
  get isEnableCode() {
    const codeReg = /^\d{6}$/;
    return codeReg.test(this.code);
  }
  get phoneError() {
    if (this.phone === '') {
      return '';
    }
    if (this.phoneErrMsg) {
      const msg = this.phoneErrMsg;
      this.phoneErrMsg = '';
      return msg;
    }
    if (!this.isEnablePhone) {
      return '！请输入正确的手机验证号码';
    }
    return '';
  }
  get codeError() {
    if (this.code === '') return '';
    if (this.validErrMSg) {
      const msg = this.validErrMSg;
      this.validErrMSg = '';
      return msg;
    }
    if (!this.isEnableCode) {
      return '请输入有效验证码';
    }
    return '';
  }

  onAreaCodeChange(code: string) {
    this.area = code;
  }

  @promiseLock
  getCode() {
    if (!this.isEnablePhone) {
      return;
    }
    trackerLoaded.then((tracker) => {
      tracker.track('ButtonClick', {
        tracking_scene: '仿长投版报名页',
        page_name: '9元报名页',
        button_name: '获取验证码',
        button_type: '普通按钮',
        tracking_subscene: '手机号待验证',
      });
    });
    return window.apis
      .postValidCode(
        {
          mobile: this.phone,
          area_code: `+${this.area}`,
        },
        { ...this.$route.query, ...getQueryFromSearch() }
      )
      .then((res: any) => {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (res.errcode === 0) {
          this.lockGetCode();
          this.toast({ icon: okIcon, value: '验证码已发送，请稍后' });
        } else {
          this.phoneErrMsg = res.errmsg;
        }
      })
      .catch(() => {
        this.toast({
          icon: warnIcon,
          value: '验证码发送失败',
        });
      });
  }
  @promiseLock
  sendConfirmReq() {
    // 已有资格，直接返回
    if (this.hasQualify) {
      return;
    }
    // 已有验证好的手机
    if (this.validPhone) {
      this.$emit('pay');
      return;
    }
    // 手机验证逻辑
    if (!this.isEnablePhone || !this.isEnableCode) {
      return;
    }
    return window.apis
      .postValidInfo(
        {
          code: this.code,
          mobile: this.phone,
          area_code: `+${this.area}`,
        },
        {
          ...this.$route.query,
          ...getQueryFromSearch(),
        }
      )
      .then((res: any) => {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (res.errcode !== 0) {
          this.validErrMSg = res.errmsg;
        } else {
          this.handleValidSucces();
        }
      });
  }
  handleValidSucces() {
    this.$emit('valid-success', this.phone);
  }
  lockGetCode() {
    this.interval = setInterval(() => {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      if (--this.times <= 0) {
        clearInterval(this.interval);
        this.interval = null;
        this.times = CODE_TIME;
      }
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 1000);
  }
  toast(config: any) {
    let toastVm;
    if ((toastVm = this.$refs.toast) && toastVm.toast) {
      toastVm.toast(config);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@style/helps.scss';
$main-btn-color: #ea632f;
$main-btn-hover-color: #f4b197;
$code-input-color: #ea632f;
$border-radius: 49px;
.phone-validate {
  position: absolute;
  top: 860px;
  width: 682px;
  padding: 46px;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  box-shadow: 0px 4px 60px 0px rgba(159, 159, 159, 0.24);

  .input-block {
    display: flex;
    align-items: center;
    width: 100%;
    height: 98px;
    overflow: hidden;
    color: #818181;
    font-size: 25px;
    background-color: #f6f5f9;
    border-radius: $border-radius;
    .icon-img {
      width: 46px;
      height: 46px;
      margin-right: 10px;
    }
    input {
      flex: 1;
      min-width: 80px;
      height: 90%;
      margin-top: 6px;
      margin-left: 20px;
      padding: 0;
      color: #615e6e;
      color: rgba(129, 129, 129, 1);
      font-weight: 400;
      font-size: 28px;
      letter-spacing: 0.65px;
      background: #f6f5f9;
      border: none;
      border-radius: $border-radius;
      &::placeholder {
        color: #b4b1bd;
      }
    }
  }
  .form-item {
    .error {
      margin-top: 4px;
      color: #f23666;
      font-size: 26px;
      letter-spacing: 0.49px;
    }
  }
  .form-item + .form-item {
    margin-top: 18px;
  }
  .input-phone {
    padding-left: 30px;
    overflow: hidden;

    input {
      margin-left: 0;
    }
  }
  .input-code {
    padding: 0px 32px;
    .get-code {
      padding: 4px 12px;
      color: $code-input-color;
      font-size: 32px;
      white-space: nowrap;
      border-radius: 8px;
      &:active {
        background-color: #ece9f6;
      }
      &.disabled {
        opacity: 0.3;
      }
    }
    .wait-time {
      color: #b4b1bd;
      font-size: 30px;
      .time-countdown {
        display: inline-block;
        width: 35px;
        text-align: right;
      }
    }
  }
  .phone-display {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 112px;
    margin-bottom: 24px;
    color: #615e6e;
    font-size: 34px;
    letter-spacing: 0.65px;
    background-color: #f6f5f9;
    border-radius: 16px;
  }
  .btn-confirm-wrapper {
    background: #fff;
  }
  .btn-confirm {
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 1);
    font-weight: 500;

    font-size: 40px;
    background: $main-btn-color;
    box-shadow: 0px 10px 32px 0px rgba(255, 119, 0, 0.34);

    @include forbid-select;
    &.disabled {
      opacity: 0.3;
    }
    &:active:not(.disabled) {
      opacity: 0.7;
    }
  }
}
</style>
